// extracted by mini-css-extract-plugin
module.exports = {"navShim":"flavours-xdl-navShim-a4ff988b","navBurger":"flavours-xdl-navBurger-c3f37dd6","line":"flavours-xdl-line-dde8739d"};